var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9.52367 9.52493H5.33319V11.0487H7.23796V12.5725H8.76177V11.0487H9.52367C10.0288 11.0487 10.5133 10.8481 10.8705 10.4908C11.2278 10.1336 11.4284 9.64915 11.4284 9.14397C11.4284 8.6388 11.2278 8.15432 10.8705 7.7971C10.5133 7.43989 10.0288 7.23921 9.52367 7.23921H6.47605C6.37502 7.23921 6.27812 7.19908 6.20668 7.12763C6.13523 7.05619 6.0951 6.95929 6.0951 6.85826C6.0951 6.75722 6.13523 6.66033 6.20668 6.58888C6.27812 6.51744 6.37502 6.47731 6.47605 6.47731H10.6665V4.9535H8.76177V3.42969H7.23796V4.9535H6.47605C5.97088 4.9535 5.48639 5.15418 5.12918 5.51139C4.77197 5.8686 4.57129 6.35309 4.57129 6.85826C4.57129 7.36343 4.77197 7.84792 5.12918 8.20513C5.48639 8.56234 5.97088 8.76302 6.47605 8.76302H9.52367C9.6247 8.76302 9.7216 8.80316 9.79304 8.8746C9.86449 8.94604 9.90462 9.04294 9.90462 9.14397C9.90462 9.24501 9.86449 9.34191 9.79304 9.41335C9.7216 9.48479 9.6247 9.52493 9.52367 9.52493Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoney);
export default __webpack_public_path__ + "static/media/icon-money.0bb35e0ddd464dd069d73f0f64729d75.svg";
export { ForwardRef as ReactComponent };